/**
 * Created by nategood on 9/27/16.
 */
import _ from 'lodash'

import config from 'scoreboard/components/config'
import constants from 'scoreboard/components/constants'

/**
 * Returns the names for all series of a scoring type.
 */
function seriesNames(scoringTypeId) {
	if (_.isUndefined(scoringTypeId) || scoringTypeId == null) {
		return []
	}
	var scoringType = config.scoringType(scoringTypeId)
	var keys = [ constants.ACTUAL_VALUE ]
	if (!scoringType.isCustomText && scoringType.thresholdNames) {
		keys = keys.concat(scoringType.thresholdNames)
	}
	return keys
}

export default seriesNames


seriesNames.__filename__ = 'scorecards/series-names.js'
